import React, { useState, useEffect } from "react";
import styled from "styled-components";

// --- styled components ---
const Wrapper = styled.div`
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const Title = styled.h1`
  font-size: 2rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 2rem;
`;

const Form = styled.form`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 2.5rem;
`;

const FileInput = styled.input`
  font-size: 0.9rem;
  color: #444;
`;

const Button = styled.button`
  padding: 0.6rem 1.2rem;
  background: linear-gradient(90deg, #2563eb, #1e40af);
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    background: linear-gradient(90deg, #1d4ed8, #1e3a8a);
    transform: scale(1.05);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const Gallery = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1.5rem;
`;

const PhotoCard = styled.div`
  position: relative;
  width: 100%;
  max-width: 300px;
  border: 1px solid #ddd;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.2s ease-in-out;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
`;

const Photo = styled.img`
  width: 100%;
  height: 200px;
  object-fit: cover;
`;

const DeleteButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: #dc2626;
  color: white;
  border: none;
  padding: 0.4rem 0.6rem;
  border-radius: 50%;
  cursor: pointer;
  font-size: 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  transition: background 0.2s ease-in-out;

  &:hover {
    background: #b91c1c;
  }
`;

// --- component ---
export default function PhotoManager() {
  const [file, setFile] = useState(null);
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchPhotos = async () => {
    try {
      const res = await fetch("https://api.pth-hokej.pl/api/gallery");
      const data = await res.json();
      setPhotos(data);
    } catch (err) {
      console.error("❌ Błąd pobierania zdjęć:", err);
    }
  };

  useEffect(() => {
    fetchPhotos();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) return;

    const formData = new FormData();
    formData.append("photo", file);

    setLoading(true);
    try {
      await fetch("https://api.pth-hokej.pl/api/gallery", {
        method: "POST",
        body: formData,
      });
      fetchPhotos();
    } catch (err) {
      console.error("❌ Błąd dodawania zdjęcia:", err);
    } finally {
      setLoading(false);
      setFile(null);
    }
  };

  const handleDelete = async (id) => {
    try {
      await fetch(`https://api.pth-hokej.pl/api/gallery/${id}`, {
        method: "DELETE",
      });
      fetchPhotos();
    } catch (err) {
      console.error("❌ Błąd usuwania zdjęcia:", err);
    }
  };

  return (
    <Wrapper>
      <Title>📸 Galeria zdjęć</Title>

      <Form onSubmit={handleSubmit}>
        <FileInput
          type="file"
          accept="image/*"
          onChange={(e) => setFile(e.target.files[0])}
        />
        <Button type="submit" disabled={loading}>
          {loading ? "⏳ Wysyłanie..." : "➕ Dodaj zdjęcie"}
        </Button>
      </Form>

      <Gallery>
        {photos.map((p) => (
          <PhotoCard key={p._id}>
            <Photo src={p.link} alt="Zdjęcie" />
            <DeleteButton onClick={() => handleDelete(p._id)}>🗑</DeleteButton>
          </PhotoCard>
        ))}
      </Gallery>
    </Wrapper>
  );
}
